/**
 * Error codes for the Auth plugin
 */
export var AuthPluginErrorCode;
(function (AuthPluginErrorCode) {
    /**
     * The operation failed due to no network connection
     */
    AuthPluginErrorCode["networkNotConnected"] = "networkNotConnected";
    /**
     * The operation failed because it would require network access but allowNetworkAccess is set to false
     */
    AuthPluginErrorCode["networkNotAllowed"] = "networkNotAllowed";
    /**
     * The operation failed because it would require user interaction but allowUserInteraction is set to false
     */
    AuthPluginErrorCode["userInteractionNotAllowed"] = "userInteractionNotAllowed";
    /**
     * The operation was canceled by the user
     */
    AuthPluginErrorCode["userCanceled"] = "userCanceled";
    /**
     * The given account is not logged in
     */
    AuthPluginErrorCode["accountNotLoggedIn"] = "accountNotLoggedIn";
    /**
     * The token request process failed.  This error is only returned if a token refresh request fails, and
     * the failure is NOT due to an invalid refresh token.  If the failure happened due to an invalid
     * refresh token, then depending on the value of allowUserInteraction option, either the sign in flow will
     * start or the 'userInteractionNotAllowed' error will be returned
     */
    AuthPluginErrorCode["tokenRequestFailed"] = "tokenRequestFailed";
    /**
     * The logout request process failed
     */
    AuthPluginErrorCode["logoutRequestFailed"] = "logoutRequestFailed";
    /**
     * An invalid option was specified
     */
    AuthPluginErrorCode["invalidOption"] = "invalidOption";
    /**
     * The operation failed due to an unknown error
     */
    AuthPluginErrorCode["unknownError"] = "unknownError";
})(AuthPluginErrorCode || (AuthPluginErrorCode = {}));
export var TokenType;
(function (TokenType) {
    /**
     * For user token
     */
    TokenType["user"] = "user";
    /**
     * For device token
     */
    TokenType["device"] = "device";
})(TokenType || (TokenType = {}));
/**
 * User interaction start points
 */
export var UserInteractionEntryPoint;
(function (UserInteractionEntryPoint) {
    /**
     * User interaction should start on the sign in page
     */
    UserInteractionEntryPoint["signIn"] = "signIn";
    /**
     * User interaction should start on the create-account page
     */
    UserInteractionEntryPoint["createAccount"] = "createAccount";
})(UserInteractionEntryPoint || (UserInteractionEntryPoint = {}));
//# sourceMappingURL=auth.js.map